import * as React from 'react';
import * as Redux from 'react-redux';
import MUIDataTable from 'mui-datatables';
import { Grid, Tooltip, Typography, Stack } from '@mui/material';
import {
  deleteProfesionesAction,
  allProfesionesAction,
  setActivoProfesionesAction,
} from '../ProfesionesAction';
import * as CONST from '../../../../constants/FieldsConst';
import { textLabels } from '../../../../helpers';
import { PARAMS_PROFESIONES } from '../ProfesionesReducer';
import { LoadingWidget } from '../../../../widgets';
import { Chip } from '@mui/material';
import ActionsListWidget from '../../../../widgets/ActionsList';
import { NameComponent } from '../../../usuario/usuarios/components/ListadoUsuarios';
import { Box } from '@mui/material';
import { Links } from '../../../docentes/materias/components/ListadoMateriasDocentes';
import { useNotification } from '../../../../helpers/Notification';
import DeleteModalComponent from '../../../../widgets/modals/DeleteModal';

const ListadoProfesiones = ({ isDelete = false, setIsDelete = () => {} }) => {
  const dispatch = Redux.useDispatch();
  const { notify } = useNotification();

  const loginStore = Redux.useSelector((state) => state.login);
  const profesionesStore = Redux.useSelector((state) => state.profesiones);

  const [loadingDelete, setLoadingDelete] = React.useState(false);
  const [openModalDelete, setOpenModalDelete] = React.useState(false);

  React.useEffect(() => {
    const fetchData = async () => {
      const payload = {};

      dispatch({ type: PARAMS_PROFESIONES, payload });
      if (profesionesStore.all && profesionesStore.all.length === 0) {
        await allProfesionesAction(dispatch, {
          ...profesionesStore.params,
          ...payload,
        });
      }
    };
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const _handleEditClick = async (id) => {
    setIsDelete(false);
    const data = profesionesStore.all.find((el) => el.id === id);
    await setActivoProfesionesAction(dispatch, data);
  };

  const _onDeleteHandler = async () => {
    setLoadingDelete(true);
    await deleteProfesionesAction(
      { dispatch, notify },
      profesionesStore.activo.id,
      profesionesStore.params,
    );
    setLoadingDelete(false);
    setOpenModalDelete(false);
  };

  const columns = [
    {
      name: CONST.ID,
      options: {
        display: loginStore.isRoot ? false : 'excluded',
        filter: false,
      },
    },
    {
      name: CONST.nombre.name,
      label: CONST.nombre.label,
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Stack direction="row">
              <NameComponent
                onClick={() => _handleEditClick(tableMeta.rowData[0])}
                mr="1em"
              >
                {value}
              </NameComponent>
              {profesionesStore.activo?.id === tableMeta.rowData[0] &&
                !isDelete && (
                  <Chip label="Editando" size="small" color="info" />
                )}
            </Stack>
          );
        },
      },
    },
    {
      name: CONST.link.name,
      label: CONST.link.label,
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Box
              sx={{
                width: '10vw',
                whiteSpace: 'nowrap',
                textOverflow: 'ellipsis',
                overflow: 'hidden',
              }}
            >
              <Links target="_blank" href={value}>
                {value}
              </Links>
            </Box>
          );
        },
      },
    },
    {
      name: CONST.desc.name,
      label: CONST.desc.label,
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: CONST.estatus.name,
      label: CONST.estatus.label,
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Tooltip
              describeChild
              title="Estatus del registro"
              placement="left"
            >
              <Chip
                label={value?.nombre ?? '-'}
                size="small"
                color={value?.id === 1 ? 'success' : 'error'}
              />
            </Tooltip>
          );
        },
      },
    },
    {
      name: CONST.actions.name,
      label: CONST.actions.label,
      options: {
        filter: false,
        sort: false,
        empty: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Stack direction="row">
              <ActionsListWidget
                id={tableMeta.rowData[0]}
                onEdit={() => _handleEditClick(tableMeta.rowData[0])}
                onDelete={async () => {
                  setIsDelete(true);
                  const data = profesionesStore.all.find(
                    (el) => el.id === tableMeta.rowData[0],
                  );
                  await setActivoProfesionesAction(dispatch, data);
                  setOpenModalDelete(true);
                }}
              />
            </Stack>
          );
        },
      },
    },
  ];

  const options = {
    filterType: 'dropdown',
    reponsive: 'scroll',
    setTableProps: () => {
      return {
        padding: 'none',
        size: 'small',
      };
    },
    rowsPerPage: 25,
    rowsPerPageOptions: [25, 50, 100],
    print: false,
    download: false,
    textLabels,
    selectableRowsHideCheckboxes: true,
    expandableRows: true,
    renderExpandableRow: (rowData, rowMeta) => {
      return <Grid container></Grid>;
    },
  };

  return (
    <Grid container>
      <Grid item md={12}>
        <LoadingWidget
          isLoading={profesionesStore.loadingAll || loadingDelete}
        />
        <MUIDataTable
          title={'Listado'}
          data={profesionesStore.all}
          columns={columns}
          options={options}
        />
      </Grid>
      {profesionesStore.activo && (
        <DeleteModalComponent
          open={openModalDelete}
          onClose={() => setOpenModalDelete(!openModalDelete)}
          onDelete={_onDeleteHandler}
        >
          <Typography variant="h6">{profesionesStore.activo.nombre}</Typography>
        </DeleteModalComponent>
      )}
    </Grid>
  );
};

export default ListadoProfesiones;
